import { eyeColorSchema } from '../../../../backend/config/classifiers/types';
import { allowManageCredentialingClassifiers } from '../../../../backend/features/permissions';
import { AuthError } from '@juvare/platform-app/App';
import { defineClassifierEntity, transformClassifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers';
import { classifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers/shared';
import { defineColumns } from '@juvare/platform-shared/features/storage';
import { defaultEyeColorData } from '../defaults/DefaultEyeColorData';
export const eyeColorEntityName = 'eyeColor';
const eyeColorColumns = defineColumns(Object.assign(Object.assign({}, classifierColumns), { ansiD20Code: {
        type: 'string-required',
        index: true,
    }, search: {
        type: 'full-text-search-required',
        language: 'english',
    } }));
export function defineEyeColorClassifier() {
    return defineClassifierEntity({
        entity: {
            version: 3,
            columns: eyeColorColumns,
            onMigrate: (params) => params.oldData,
            onTransformColumns: (context, params) => {
                return Object.assign(Object.assign({}, transformClassifierColumns(params)), { ansiD20Code: params.data.ansiD20Code, search: [params.data.name, params.data.ansiD20Code, params.data.status].join(' ') });
            },
            onAnonymousAuthList: (appState, response) => response,
            onAuthPost: (appState, userState) => {
                if (!allowManageCredentialingClassifiers(userState)) {
                    throw new AuthError('Unauthorized');
                }
            },
        },
        defaultData: defaultEyeColorData,
        publicData: true,
    }, eyeColorSchema);
}
